<template>
  <div class="row">
    <div class="col-lg-3 ml-lg-auto">
      <div class="rounded overflow-hidden bg-white mr-5">
        <div
          class="d-flex justify-content-between align-items-center bg-light p-3"
        >
          <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
          <span>Redefinição de senha</span>
        </div>
        <div class="p-3">
          <form @submit.prevent="onSubmit">
            <div class="alert alert-danger" v-show="authenticated_user?.email_verified_at == null && authenticated_user?.id">
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
              ></font-awesome-icon>
              Primeiro login, altere sua senha
            </div>
            
            <div class="form-group">
              <label>Email</label>
              <input
                type="text"
                class="form-control"
                v-model="user.email"
                placeholder="Login"
                disabled
              />
            </div>

            <div class="form-group">
              <label>Senha</label>
              <input
                type="password"
                class="form-control"
                v-model="user.password"
                placeholder="Senha"
              />
            </div>

            <div class="d-flex">
              <button class="btn btn-info ml-auto">
                <font-awesome-icon
                  :icon="['fas', 'sign-in-alt']"
                ></font-awesome-icon>
                Redefinir senha
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  import MultiSelect from 'primevue/multiselect'

  import useCompanies from '@/modules/Company.js'
  import useUserProfiles from '@/modules/UserProfile.js'
  import useUsers from '@/modules/User.js'

  export default {
    components: {
        MultiSelect
    },
    setup() {
      const route = useRoute()
      const router = useRouter()
      const store = useStore()

      const authenticated_user = store.getters['authenticated_user']
      
      const loading = ref(true)
      const user_form = ref(null)
      const user = ref({
        id: null,
        user_profile_id: null,
        name: '',
        rg: '',
        cpf: '',
        email: '',
        email_verified: '',
        password: '',
        occupation: '',
        office: '',
        active: '',
        companies: [],
      })

      const { companies } = useCompanies()
      const { user_profiles } = useUserProfiles()
      const { getUser } = useUsers()

      const onSubmit = () => {
        if (authenticated_user) {
          if (!authenticated_user.email_verified_at) {
            user.value.email_verified = true

            axios.post('api/updatePassword', user.value)
              .then((response) => {
                if (response.statusText == 'OK')
                  router.push('/')
              })
          } else {
            axios.post('api/updatePassword', user.value)
              .then((response) => {
                if (response.statusText == 'OK')
                  router.push('/')
              })
          }
        } else {
          axios.post('api/updatePassword', user.value)
            .then((response) => {
              if (response.statusText == 'OK')
                router.push('/login')
            })
        }
      }

      onMounted(async () => {
        await getUser(route.params.id).then((response) => {
          user.value = response.data.data
          user.value.companies = user.value.companies.map(
            (company) => company.id,
          )
        })

        loading.value = false
      })

      return {
        route,
        companies,
        user_profiles,
        user_form,
        user,
        onSubmit,
        router,
        authenticated_user,
      }
    },
  }
</script>